import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Heading from '../components/heading/Heading';
import Text from '../components/text/Text';
import Button from '../components/buttons/Button';
import envelopeIco from './../images/envelope-ico.svg'
import TagManager from 'react-gtm-module'
import lawForms from './../static-data/law-forms.json';
import proffessions from './../static-data/professions.json';
import getDataFromUrl from '../services/getDataFromUrl';
import phoneIco from './../images/call-us.svg';
import writeIco from './../images/write-us.svg';
import ButtonsNav from './../components/buttons-nav/ButtonsNav';
import { useNavigate } from "react-router";

const Thanks = ( props ) => {
    const dispatch = useDispatch()
    let [ getPrice, setGetPrice ] = useState(0);
    let callNumber      = useSelector(state => state.callNumber);
    let callEmail      = useSelector(state => state.callEmail);
    let isShop      = useSelector(state => state.isShop);
    let urlFormFinish       = useSelector(state => state.urlFormFinish)
    let urlFormFinishExternal       = useSelector(state => state.urlFormFinishExternal)
    let [ load, setLoad ] = useState(false);
    let email = useSelector(state => state.email)
    let [ counter, setCounter ] = useState(15);
    let navigate = useNavigate();

    //data
    let identificator       = useSelector(state => state.identificator)
    let products            = useSelector(state => state.products)
    let repurchase          = useSelector(state => state.repurchase)
    let leasingTime         = useSelector(state => state.leasingTime)
    let initialCharge       = useSelector(state => state.initialCharge)
    let productPrice        = useSelector(state => state.productPrice)
    let productPriceEnd     = useSelector(state => state.productPriceEnd)
    let activeContract      = useSelector(state => state.selectedLease)
    let tax                 = useSelector(state => state.tax)
    let selectedLease       = useSelector(state => state.selectedLease)
    let modernLease         = useSelector(state => state.modernLease)
    let finalRate           = useSelector(state => state.finalRate)
    let rateFrequency       = useSelector(state => state.rateFrequency)
    let providerPostal      = useSelector(state => state.providerPostal)
    let chargePrice         = useSelector(state => state.chargePrice)
    let minMonth            = useSelector(state => state.minMonth)
    let maxMonth            = useSelector(state => state.maxMonth)
    let providerName        = useSelector(state => state.providerName)
    let providerNip         = useSelector(state => state.providerNip)

    // 
    let nip                     = useSelector(state => state.nip)
    let companyName             = useSelector(state => state.companyName)
    let companyAddress          = useSelector(state => state.companyAddress)
    let postalCustomer          = useSelector(state => state.postalCustomer)
    let city                    = useSelector(state => state.city)
    let companyStart            = useSelector(state => state.companyStart)
    let registryType            = useSelector(state => state.registryType)
    let idNumber                = useSelector(state => state.idNumber)
    let phone                   = useSelector(state => state.phone)
    let lawForm                 = useSelector(state => state.lawForm)
    let profession              = useSelector(state => state.profession)
    let employeesNumber         = useSelector(state => state.employeesNumber)
    let website                 = useSelector(state => state.website)
    let additionalCompanyAddress          = useSelector(state => state.additionalCompanyAddress)
    let additionalPostalCustomer          = useSelector(state => state.additionalPostalCustomer)
    let additionalCity                    = useSelector(state => state.additionalCity)

    //
    let authorizedPersons        = useSelector(state => state.authorizedPersons)

    //
    let taxArrears                  = useSelector(state => state.taxArrears)
    let taxArrearsPrice             = useSelector(state => state.taxArrearsPrice)
    let ZUSarrears                  = useSelector(state => state.ZUSarrears)
    let ZUSarrearsPrice             = useSelector(state => state.ZUSarrearsPrice)
    let enforcementProceedings      = useSelector(state => state.enforcementProceedings)
    let enforcementProceedingsPrice = useSelector(state => state.enforcementProceedingsPrice)
    let prevYearRevenues            = useSelector(state => state.prevYearRevenues)
    let revenueOld                  = useSelector(state => state.revenueOld)
    let revenueScoreOld             = useSelector(state => state.revenueScoreOld)
    let revenueProfitOld            = useSelector(state => state.revenueProfitOld)
    let revenue                     = useSelector(state => state.revenue)
    let revenueFrom                 = useSelector(state => state.revenueFrom)
    let revenueTo                   = useSelector(state => state.revenueTo)
    let revenueScore                = useSelector(state => state.revenueScore)
    let revenueProfit               = useSelector(state => state.revenueProfit)
    //
    let realEstatesItems                 = useSelector(state => state.realEstatesItems)
    let fundsItems                       = useSelector(state => state.fundsItems)
    //
    let otherCreditsItems                = useSelector(state => state.otherCreditsItems)
    //
    let authCheckOne        = useSelector(state => state.authCheckOne)
    let authCheckTwo        = useSelector(state => state.authCheckTwo)
    let authName            = useSelector(state => state.authName)
    let authSurname         = useSelector(state => state.authSurname)
    let authAddress         = useSelector(state => state.authAddress)
    let authPesel           = useSelector(state => state.authPesel)
    let authId              = useSelector(state => state.authId)
    let authCheckThree      = useSelector(state => state.authCheckThree)
    let authCheckFour       = useSelector(state => state.authCheckFour)
    let authCheckFive       = useSelector(state => state.authCheckFive)
    let authCheckSix        = useSelector(state => state.authCheckSix)
    let comments            = useSelector(state => state.comments)
    let postman             = useSelector(state => state.postman)
    let emailbill           = useSelector(state => state.emailbill)

    useEffect(() => {
      if ( !load ) {
        dispatch({ type: 'END_PAGE_CHANGE', value: true })
        // runDataLayer();
        // runCounter();
        // getUrlParams();
        if(typeof window !== "undefined") {
            window.dataLayer.push({'event':'pageview'});
        }
      }
      
    }, [load])

    let prev = () => {

        window.location.href = window.location.origin;
        // navigate('/krok/5')
    }
    dispatch({ type: 'STEPS_CHANGE', value: 6 })

    const getUrlParams = async() => {
        let getEmail = getDataFromUrl('email');
        let getNumberCall = getDataFromUrl('callNumber');
        let getEmailCall = getDataFromUrl('callEmail');
        let getPriceValue = getDataFromUrl('price');

        await dispatch({ type: 'EMAIL_CHANGE', value: getEmail } )
        await dispatch( {type: 'CALL_NUMBER_CHANGE', value:  getNumberCall } )
        await dispatch( {type: 'CALL_EMAIL_CHANGE', value:  getEmailCall } ) 
        setGetPrice(getPriceValue);
    }

    const runCounter = () => {
        const run = setInterval(function() {
            if(counter == 1) {
                setCounter(--counter)
                clearInterval(run);
                prev();
            }else{
                setCounter(--counter)
            }
        }, 1000);
    }

    let searchInLawForms = (val) => {
        let key = ''
        lawForms.map( item  => {
            if ( item.val == val) {
                key = item.key;
            }
        })
        return key;
    }
    let searchInProffesions = (val) => {
        let key = ''
        proffessions.map( item  => {
            if ( item.val == val) {
                key = item.key;
            }
        })
        return key;
    }

    let reconvertPrice = (val) => {
        if(val && val.length > 0) {
            let valuePrice = val.replace(/ /g,'');
            valuePrice = valuePrice.replace('zł', '');
            valuePrice = valuePrice.replace(',','.');
    
            return(valuePrice);
        }
    }

    const runDataLayer = () => {
        let data = [
            {
                "identificator": identificator,
                "isShop": isShop,
                "products": products,
                "type": selectedLease,
                "value": productPrice,
                "productPriceEnd": reconvertPrice(productPriceEnd),
                "price": reconvertPrice(chargePrice),
                "initial": reconvertPrice(initialCharge),
                "tax": reconvertPrice(tax),
                "repurchase": repurchase,
                "finalRate": finalRate,
                "rateFrequency": rateFrequency,
                "minMonths": minMonth,
                "maxMonths": maxMonth,
                "months": leasingTime,
                "selectedLeasing": activeContract,
                "enableModernLease": modernLease,
                "providerName": providerName,
                "providerPostal": providerPostal,
                "providerNip": providerNip,
                'callNumber': callNumber
            },
            {
                "nip": nip,
                "company": companyName,
                "address": companyAddress,
                "city": city,
                "email": email,
                "postcode": postalCustomer,
                "companyStart": companyStart,
                "registryType": registryType,
                "krs": idNumber,
                "phone": phone,
                "company_type": searchInLawForms(lawForm),
                "company_sector": searchInProffesions(profession),
                "employeesNumber": employeesNumber,
                "www": website,
                "additionalCompanyAddress": additionalCompanyAddress,
                "additionalPostalCustomer": additionalPostalCustomer,
                "additionalCity": additionalCity,
            },
            // {
            //     "representatives": authorizedPersons
            // },
            {
                "taxArrears": taxArrears,
                "taxArrearsPrice": reconvertPrice(taxArrearsPrice),
                "ZUSarrears": ZUSarrears,
                "ZUSarrearsPrice": reconvertPrice(ZUSarrearsPrice),
                "enforcementProceedings": enforcementProceedings,
                "enforcementProceedingsPrice": reconvertPrice(enforcementProceedingsPrice),
                "prevYearRevenues": prevYearRevenues,
                "revenue": reconvertPrice(revenue),
                "revenueOld": reconvertPrice(revenueOld),
                "revenueScoreOld": revenueScoreOld,
                "revenueProfitOld": reconvertPrice(revenueProfitOld),
                "revenueFrom": revenueFrom,
                "revenueTo": revenueTo,
                "revenueScore": revenueScore,
                "revenueProfit": reconvertPrice(revenueProfit),
            },
            {
                "realEstatesItems": realEstatesItems,
                "fundsItems": fundsItems,
            },
            {
                "otherCreditsItems": otherCreditsItems
            },
            {
                "authCheckOne": authCheckOne,
                "authCheckTwo": authCheckTwo,
                "authName": authName,
                "authSurname": authSurname,
                "authAddress": authAddress,
                "authPesel": authPesel,
                "authId": authId,
                "authCheckThree": authCheckThree,
                "authCheckFour": authCheckFour,
                "authCheckFive": authCheckFive,
                "authCheckSix": authCheckSix,
                "comments": comments,
                "postman": postman,
                "emailInvoice": emailbill,
            },
        ];
        // const tagManagerArgs = {
        //     dataLayer: {
        //         data: data,
        //         page: 'dziekujemy'
        //     },
        //     dataLayerName: "FinishForm"
        // }
        window.dataLayer.push({
            dataLayerName: "FinishForm",
            page: 'dziekujemy',
            data: data
        })
        // TagManager.dataLayer(tagManagerArgs)
    }

    return (
        <section className="form">
            <div className="container thanks-container">
                <div className="thanks">
                    <div className="text-box">
                        <Heading title={`Thank you for submitting your application!`} />
                        {productPrice < 50000 &&
                        <>
                            <Text text={`We will contact you soon.`} />
                        </>
                        }
                        {productPrice >= 50000 &&
                        <>
                            <Text text={`The above-mentioned calculation will be processed by our credit department. Due to the high value, additional documents or information may be required. Our sales representative will reach out to discuss the details.`} />
                        </>
                        }
                    </div>
                    <div className="contact-box">
                        <div className="item">
                            <p>Need a help?</p>
                        </div>
                        <a href="tel:+971 4 873 59 00" className="item">
                            <img src={phoneIco} alt="" />
                            <p><strong>Call us</strong></p>
                        </a>
                        <a href="mailto:service@grenke.ae" className="item">
                            <img src={writeIco} alt="" />
                            <p><strong>Write us an email</strong></p>
                        </a>
                    </div>
                </div>
                <ButtonsNav prev={() => prev()} />
            </div>
        </section>
    )
    
}

export default Thanks;